import { render, staticRenderFns } from "./PropostaPendencias.vue?vue&type=template&id=e923287e"
import script from "./PropostaPendencias.vue?vue&type=script&lang=js"
export * from "./PropostaPendencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports